import React from 'react'
import './Details.css'
import StdPerfTable from '../Performance/StdPerfTable'
import MonthEndPerfTable from '../Performance/MonthEndPerfTable'
import CalYearPerfTable from '../Performance/CalYearPerfTable'
import i18n from '../../../i18n'
import CompText from '../Compliance/CompText'
import { useSelector } from 'react-redux'
import ProgressBar from '../Components/ProgressBar'
import { SomethingWentWrong } from '../Components/ErrorHandle'
import DetailsTable from './DetailsTable'

const Details = () => {
  const data = useSelector(state => state.fundData.data)
  const hasBlendedData = useSelector(state => state.fundData.hasBlendedData)
  const loadingPerformanceData = useSelector(state => state.fundData.loadingPerformanceData)
  const errorPerformanceData = useSelector(state => state.fundData.errorPerformanceData)
  const hasLevels = data.filter(x => x.levels !== null);
  const hasPerfData = hasLevels.length > 0
  
  if (errorPerformanceData) {
    return(
      <div>
        <SomethingWentWrong />
        <CompText pane='Details' />
      </div>
    )
  }

  //if we are still fetching data and current loaded data has aggs
  const ProgressBarIfGettingBlendedData = () => {
    return (
      (loadingPerformanceData && hasPerfData && hasBlendedData) && (
        <div>
          <ProgressBar message={i18n.t('loading_blended_performance')}/>
          <div style={{ marginBottom: '65px' }} />
        </div>
      )
    );
  };

  if (loadingPerformanceData && !hasPerfData){
    return(
      <div>
        <ProgressBar title={'STANDARDIZED PERFORMANCES'} message={i18n.t('loading_performance')} />
        <CompText pane='Details' />
      </div>
    )
  }

  return (
    <div>
      <ProgressBarIfGettingBlendedData />
      <div style={{ marginBottom: '65px' }} />
      <div className='fund-char-details'>
        <DetailsTable />
        <div style={{ marginBottom: '65px' }} />
        <StdPerfTable />
        <div style={{ marginBottom: '65px' }} />
        <MonthEndPerfTable />
        <div style={{ marginBottom: '65px' }} />
        <CalYearPerfTable />
        <div style={{ marginBottom: '65px' }} />
        <CompText pane='Details' />
      </div>
    </div>
  )
}

export default Details
